import { NgModule } from "@angular/core";
import { ApplyFunctionOrValue } from "./apply-function-or-value/apply-function-or-value.pipe";
import { BoolToStringPipe } from "./bool-to-string/bool-to-string.pipe";
import { CapitalizeCasePipe } from "./capitalize-case/capitalize-case.pipe";
import { DynamicPipe } from "./dynamic-pipe/dynamic-pipe.pipe";
import { EmptyTextPipe } from "./empty-text/empty-text.pipe";
import { MomentPipe } from "./moment/moment.pipe";
import { MoneyPipe } from "./money/money.pipe";
import { PathBuilderPipe } from "./path-builder/path-builder.pipe";
import { QueryParamsBuilderPipe } from "./query-params-builder/query-params-builder.pipe";
import { TruncateTextPipe } from "./truncate-text/truncate-text.pipe";
import { CheckEditUserPermissionsPipe } from "./check-edit-user-permissions/check-edit-user-permissions.pipe";

@NgModule({
  declarations: [
    ApplyFunctionOrValue,
    BoolToStringPipe,
    CapitalizeCasePipe,
    DynamicPipe,
    EmptyTextPipe,
    MomentPipe,
    MoneyPipe,
    PathBuilderPipe,
    QueryParamsBuilderPipe,
    TruncateTextPipe,
    CheckEditUserPermissionsPipe,
  ],
  exports: [
    ApplyFunctionOrValue,
    BoolToStringPipe,
    CapitalizeCasePipe,
    DynamicPipe,
    EmptyTextPipe,
    MomentPipe,
    MoneyPipe,
    PathBuilderPipe,
    QueryParamsBuilderPipe,
    TruncateTextPipe,
    CheckEditUserPermissionsPipe,
  ],
})
export class PipesModule {}
